import apiUrls from "../../config/apiUrls";
import { postData } from "../../services/api";
import IApiResponse from "../../types/IApiResponse";
import handleApiResponse from "../../utils/handleApiResponse";

export const addUpdateClubSortListData = async (
  userData: number,
  selectedClubIds: number[],
  startLoading: () => void,
  stopLoading: () => void,
  setDisplayNotification: (value: boolean) => void,
  setNotificationContent: (content: JSX.Element) => void,
  isRemovePlayer?: boolean,
  navigate: (path: string) => void = () => {}
) => {
  startLoading();
  const filteredPlayerIds = selectedClubIds.filter((value) => Number.isInteger(value));
  const requestParameters = {
    id: userData,
    shortListName: "mySortList",
    clubIds: filteredPlayerIds,
    isRemove: isRemovePlayer,
  };
  const response: IApiResponse<any> = await postData(apiUrls.AddOrUpdateClubShortList, requestParameters);
  handleApiResponse(
    response,
    (addSortListData) => {
      stopLoading();
      if (addSortListData) {
        setDisplayNotification(true);
        localStorage.removeItem("removedclubIds");
        setTimeout(() => {
          setDisplayNotification(false);
          setNotificationContent(<div></div>);
        }, 5000);
      }
    },
    (error) => {
      stopLoading();
      console.error("Error fetching add or update data:", error);
    }
  );
};
